import './preloader.less';
import $ from 'jquery';

export default class PreLoader
{
    constructor(options)
    {
        const defaults = PreLoader.getDefaultOptions();
        this.options = $.isPlainObject(options) ? $.extend(true, defaults, options) : defaults;
        this.$element = $(this.options.selector);
        this.$loader = $(this.options.block);
        this.$loader.addClass(this.options.class);
    }

    static getDefaultOptions()
    {
        return {
            speed: 200,
            selector: 'body',
            block: '<div class="maximaster-preloader"></div>',
            class: ''
        }
    };

    show(speed)
    {
        speed = this.speed(speed);
        this.$element.append(this.$loader);
        this.$loader.stop(true).fadeIn(speed);
    }

    hide(speed)
    {
        speed = this.speed(speed);
        const loader = this.$loader;
        loader.stop(true).fadeOut(speed, function () {
            loader.detach();
        });
    }

    speed(speed)
    {
        return $.isNumeric(speed) ? (parseInt(speed) | 0) : this.options.speed;
    }

    static isString(variable, noEmpty)
    {
        let answer = !!(variable === '' || (variable && variable.split));
        if (noEmpty === true) {
            answer = (answer && variable.length > 0);
        }

        return answer;
    };
}


// WEBPACK FOOTER //
// ./modules/preloader/index.js